import React from "react";
import "./404page.css";

export default () => {
  return (
    <div id="main">
      <div class="fof">
        <h1>Error 404</h1>
        <h3>La pagina che stai cercando non esiste</h3>
      </div>
    </div>
  );
};
